import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import {ArrowDropDown, ArrowDropUp} from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {Divider, useMediaQuery} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {RoutePaths} from "../../../util/constants";
import {RootState, useAppDispatch, useAppSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {logOut} from "../../../store/auth/ActionCreators";

const ProfileDropdown = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const fullName = useAppSelector((state: RootState) => state.authReducer.loggedInUser.full_name)
    const userPicture = useAppSelector((state: RootState) => state.authReducer.loggedInUser.profile_picture)
    const isAdmin = useAppSelector((state: RootState) => state.authReducer.loggedInUser.is_admin)
    const isClient = useAppSelector((state: RootState) => !!state.authReducer.loggedInUser.client_id)
    const clientContactEmail = useAppSelector((state: RootState) => state.clientReducer.selectedClient.contact)
    const currentClientEmail = useAppSelector((state: RootState) => state.authReducer.loggedInUser.email)
    const dispatch = useAppDispatch()

    const {t} = useTranslation()
    const navigate = useNavigate()
    const matches = useMediaQuery('(max-width:1050px)');

    const handleOnProfileClick = () => {
        setAnchorEl(null)
    }

    const handleOpenAccountMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }

    const handleLogOut = () => {
        setAnchorEl(null)
        dispatch(logOut(true))
    }

    const handleAdminPanel = () => {
        setAnchorEl(null)
        navigate(RoutePaths.ADMIN_PANEL_DASHBOARD)
    }

    const handleClientPanel = () => {
        setAnchorEl(null)
        navigate(clientContactEmail === currentClientEmail ? RoutePaths.CLIENT_PANEL_DASHBOARD : RoutePaths.CLIENT_PANEL_VOUCHERS)
    }

    return (
        <>
            <Button variant="outlined"
                    size="small"
                    aria-controls="account-menu"
                    aria-haspopup="true"
                    onClick={handleOpenAccountMenu}>
                <Avatar
                    alt={fullName}
                    src={userPicture}
                    sx={matches ? {width: 24, height: 24} : {width: 24, height: 24, mr: 0.5}}
                />
                {!matches ? fullName : null}
                {Boolean(anchorEl) ? <ArrowDropUp fontSize="small"/> :
                    <ArrowDropDown fontSize="small"/>}
            </Button>
            <Menu
                id="account-menu"
                sx={{mt: 1}}
                anchorEl={anchorEl}
                keepMounted
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                {isAdmin &&
                    <MenuItem onClick={handleAdminPanel}>{t('admin_panel')}</MenuItem>}
                {isClient &&
                    <MenuItem onClick={handleClientPanel}>{t('client_panel')}</MenuItem>}
                {!isAdmin && !isClient && <MenuItem
                        component={RouterLink}
                        to={RoutePaths.PROFILE}
                        onClick={handleOnProfileClick}>{t('your_profile')}</MenuItem>}
                <Divider/>
                <MenuItem onClick={handleLogOut}>{t('log_out')}</MenuItem>
            </Menu>
        </>
    )
}

export default ProfileDropdown